module.exports = __webpack_public_path__ + "img/qixiangzhan.b9fbdbe7.png";